/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

// Component imports
import { Row } from 'antd';
import { DotChartOutlined } from '@ant-design/icons';

const ChartLoader = ({ height = 264, className }) => {
  return (
    <Row
      className={classNames('bg-skeleton border-radius-base p-5 mb-6', className)}
      style={{ height: height }}
      align="middle"
      justify="center"
    >
      <DotChartOutlined className="text-muted opacity-60 fs-xxxxl" />
    </Row>
  );
};

ChartLoader.propTypes = {
  height: PropTypes.number,
  className: PropTypes.string
};

export default ChartLoader;
